import {CSSProperties, useEffect} from 'react';
import { useStudyWithUserCheck, useSubmitStudyForm } from '@vivli/features/studies/infrastructure/hook';
import { useParams } from 'react-router';
import { SubmitNewStudyComponent, SubmitStudyFormComponent } from '@vivli/features/studies/components';
import { StudyContextWrapper } from '@vivli/features/studies/infrastructure/wrappers';
import { FormProvider } from 'react-hook-form';

const containerStyle: CSSProperties = {
    backgroundColor: 'rgb(233, 234, 239)',
    overflow: 'hidden',
    transform: 'translate3d(0,0,0)',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '100%',
    flexGrow: 2,
    height: '100%'
};

export const SubmitStudyFeature = () => {
    const { studyId } = useParams();
    const { study, studyUsedIn, studyIpdDataPackageSubmitted } = useStudyWithUserCheck(studyId);
    const formApi = useSubmitStudyForm(study);

    useEffect(() => {
        if (!study || !studyId) return;

        formApi.reset(study);
    }, [study]);

    /* If there is no studyId (user is creating a new study), return path 1. Else return Draft path */
    if (!studyId) {
        return <SubmitNewStudyComponent />;
    }

    return (
        <div style={containerStyle}>
            <FormProvider {...formApi}>
                <StudyContextWrapper study={study} usedIn={studyUsedIn} studyIpdPackageSubmitted={studyIpdDataPackageSubmitted}>
                    <SubmitStudyFormComponent />
                </StudyContextWrapper>
            </FormProvider>
        </div>
    );
};
